import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungBerlin() {
  return (
    <CityPageTemplate
      city="Berlin"
      slug="berlin"
      intro="Als eine der größten Städte Deutschlands bietet Berlin viele Möglichkeiten – aber auch besondere Herausforderungen beim Vermögensaufbau angesichts steigender Mietpreise."
      description="Unabhängige & digitale Finanzberatung für Berlin: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
